import { render, staticRenderFns } from "./DormRoomAddView.vue?vue&type=template&id=d79f6386&scoped=true&"
import script from "./DormRoomAddView.vue?vue&type=script&lang=js&"
export * from "./DormRoomAddView.vue?vue&type=script&lang=js&"
import style0 from "./DormRoomAddView.vue?vue&type=style&index=0&id=d79f6386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79f6386",
  null
  
)

export default component.exports